var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Modal, Button } from '@appspotr/ui-kit';
import { Icon } from '@project/components/base';
import { ModalText } from './styles';
import injectReducer from '../../utils/injectReducer';
import reducer from '../PaymentEntry/reducer';
import { selectSignup } from '../../store/signup/selectors';
import { ModalFooterButtonWrapper } from '../../components/ConfigAccountModals/styles';
import { ModalFooterWrapper } from '../../components/ContactSupportModal/styles';
import { ModalContentWrapper } from '../../components/base';
import { PermissionsWrapper } from '../../components/PermissionsWrapper';
var UpdateDevPlanModal = function (_a) {
    var open = _a.open, closeModal = _a.closeModal, goToDevPlanPurchase = _a.goToDevPlanPurchase, goToPaymentSettings = _a.goToPaymentSettings, organization = _a.organization, updateDev = _a.updateDev, _b = _a.paymentModal, paymentModal = _b === void 0 ? false : _b, nonClosable = _a.nonClosable;
    var loading = updateDev.loading;
    var nonAdminDescription = function () { return (_jsx(ModalText, { children: "You can ask your organization admin, ".concat(organization.contact_person, "\n            (").concat(organization.contact_email, ") to upgrade your developer plan.") })); };
    var triggerNotifyAdmin = function () {
        window.location.href = "mailto:".concat(organization.contact_email, "?subject='Action needed in ").concat((organization === null || organization === void 0 ? void 0 : organization.name) || 'organization', "'");
    };
    var nonAdminActionButton = function () { return (_jsxs(Button, __assign({ disabled: loading, onClick: function () {
            triggerNotifyAdmin();
            closeModal();
        } }, { children: [_jsx(Icon, { style: { marginLeft: '10px', fontSize: '14px', marginRight: '5px' }, className: "fa fa-envelope" }), "Notify Admin"] }))); };
    var renderFooter = function () { return (_jsx(ModalFooterWrapper, { children: _jsx(ModalFooterButtonWrapper, __assign({ pushRight: true }, { children: _jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: [
                    "org:".concat(organization, ":orgadmin"),
                    'partner:123:organizations',
                ], AlternateChildren: function () { return nonAdminActionButton(); } }, { children: _jsx(Button, __assign({ disabled: loading, onClick: function () {
                        if (paymentModal) {
                            goToPaymentSettings(organization === null || organization === void 0 ? void 0 : organization.id);
                        }
                        else {
                            goToDevPlanPurchase(organization === null || organization === void 0 ? void 0 : organization.id);
                        }
                        closeModal();
                    } }, { children: paymentModal
                        ? 'Configure Payment method'
                        : 'Select Developer Plan' })) })) })) })); };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ title: paymentModal
                ? 'Update your card details'
                : 'You can’t conquer the world without a Plan', isOpen: open }, (!loading && !nonClosable ? { closeModal: closeModal } : undefined), { footer: renderFooter(), size: "sm" }, { children: _jsxs(ModalContentWrapper, __assign({ space: true }, { children: [_jsx(ModalText, { children: paymentModal
                            ? "For some reason we couldn't complete your latest transaction."
                            : "In order to create apps with Appspotr you need to select a Developer Plan." }), _jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: [
                            "org:".concat(organization, ":orgadmin"),
                            'partner:123:organizations',
                        ], AlternateChildren: function () { return nonAdminDescription(); } }, { children: _jsx(ModalText, { children: paymentModal
                                ? "Please check your payment details and provide a working card to continue using Appspotr. "
                                : "Just click the button and we\u2019ll get you set up in no time. " }) }))] })) })) }));
};
var mapStateToProps = function (state) { return ({
    updateDev: selectSignup(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    goToDevPlanPurchase: function (orgId) {
        dispatch(push("/organizations/".concat(orgId, "/developerPlans")));
    },
    goToPaymentSettings: function (orgId) {
        dispatch(push("/organizations/".concat(orgId, "/payments")));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var withReducer = injectReducer({
    key: 'paymentSettings',
    reducer: reducer,
});
export default compose(withReducer, withConnect)(UpdateDevPlanModal);
